import type { EntityType } from '@/types/watchlist'

/**
 * Watchlist 实体类型映射的唯一真相源 —— 右上角弹窗(WatchlistDropdown/Item)
 * 共用,杜绝 WatchlistItem / WatchlistDropdown 两份副本漂移。
 */

/** 渲染顺序(按业务重要性,跟 backend system view 的 display_order 对齐) */
export const ENTITY_TYPE_ORDER: EntityType[] = [
  'task',
  'review',
  'reservation',
  'conversation',
  'listing',
  'intent',
  'purchase',
  'material_request',
]

/**
 * 实体类型 → i18n key suffix，渲染时由消费方 t(`chrome:watchlist.entityType.${ENTITY_TYPE_I18N_KEY[type]}`)。
 *
 * @deprecated 旧名 entityTypeNames（英文硬编码）已迁到 i18n；新代码用 ENTITY_TYPE_I18N_KEY。
 *             保留 entityTypeNames 别名仅供现有测试断言 .toBeTruthy() 通过（key 本身非空即真）。
 */
export const ENTITY_TYPE_I18N_KEY: Record<EntityType, string> = {
  task: 'task',
  listing: 'listing',
  reservation: 'reservation',
  review: 'review',
  intent: 'intent',
  purchase: 'purchase',
  material_request: 'material_request',
  conversation: 'conversation',
}

/**
 * @deprecated 保留兼容层供测试文件 import。值为 i18n key suffix（非翻译后的显示文字）。
 *             渲染层请改用 ENTITY_TYPE_I18N_KEY + t()。
 */
export const entityTypeNames: Record<EntityType, string> = ENTITY_TYPE_I18N_KEY

/** 弹窗行点击跳转的列表页路由 */
export const entityTypeRoutes: Record<EntityType, string> = {
  task: '/tasks',
  listing: '/listings',
  reservation: '/reservations',
  review: '/reviews',
  intent: '/intents',
  purchase: '/procurement',
  material_request: '/material-requests',
  conversation: '/inbox',
}

/**
 * 每个 source 的 "My Watchlist" system view 的 SnowflakeID
 *
 * 来自 main-api seed 文件 scripts/sql/2026-05-23_seed_watchlist_system_views.sql +
 * 2026-06-12_seed_missing_watchlist_views.sql(10^17 + 99..105,连续段,
 * hand-picked 便于 ops 识别为 seed row)。弹窗点击行 → 跳对应列表页带 ?viewId=,
 * 让列表页选中该 source 的 watchlist view。seed 未跑的环境该 id 不存在 →
 * list page fall back 默认 view(退化不报错)。
 */
export const ENTITY_TYPE_WATCHLIST_VIEW_ID: Partial<Record<EntityType, string>> = {
  task: '100000000000000099',
  listing: '100000000000000100',
  review: '100000000000000101',
  reservation: '100000000000000102',
  intent: '100000000000000103',
  // 采购单(entity_type 'purchase'):视图 104 原本给已删的 procurement_order 建的,source 已是 purchase;
  // 2026-10-05 后端给 PurchaseModel 补上 related_users,这个视图才查得动
  purchase: '100000000000000104',
  conversation: '100000000000000105',
  // material_request 后端已删,不 seed
}
